import React from "react";
import { CustomFlowbiteTheme, Modal } from "flowbite-react";
import { IoIosWarning } from "react-icons/io";
import { useModal } from "../../../../hooks/ModalContext";

interface ModalAvisoProps {
  message?: string;
}

export const ModalAviso = ({ message }: ModalAvisoProps) => {
  const { onClose, openAvisoModal } = useModal()
  const themeModal: CustomFlowbiteTheme['modal'] = {
    root: {
      base: 'fixed top-0 right-0 left-0 z-40 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full'
    }
  }
  //TODO: Fazer uma condicional melhor
  const isWarningButton = openAvisoModal.title === "Atenção! O contrato possui parcela(s) com rematricula"

  return (
    <>
      <Modal
        // onClose={() => onClose(true)}
        show={openAvisoModal.isOpen}
        // show={true}
        popup={true}
        size={"md"}
        onClick={() => onClose(false, false, true)}
        theme={themeModal}
      >
        <Modal.Body>
          <div className="flex items-center justify-center flex-col p-6">
            <IoIosWarning className="fill-amber-500 m-4" size={70} />
            <p className="font-medium text-lg text-center m-2 text-gray-800 w-full">{openAvisoModal.title !== 'AVISO' ? openAvisoModal.title : message}</p>
            {
              isWarningButton && (
                <div className="flex items-center gap-4 text-sm w-full ">
                  <button className="bg-primary text-white px-4 py-2 rounded-md mt-4 w-full" onClick={() => onClose(false, false, true)}>Estou ciente!</button>
                  {/* <button className="bg-error text-white px-4 py-2 rounded-md mt-4 w-full" onClick={() => rematricula(false)}>Não quero incluir rematricula(s)</button> */}
                </div>
              )
            }
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}